// src/pages/volunteer/ReStores.js
import React from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import dummyImage from "../../assets/images/volunteer/restore.webp"; // Add an image if available

const ReStores = () => {
  const details = `
    Volunteers are the heart of the ReStore, playing a vital role in Habitat Buffalo’s local homebuilding mission. You don’t have to lift a hammer to help build a home! From customer service to interior decorating, the ReStore offers various volunteer options geared toward your interests and skills. Best of all, no experience is necessary.
  `;

  const requirements = [
    "Volunteers must be at least 14 years of age to participate.",
    "14 and 15-year-old volunteers must have a chaperone present during their shift.",
  ];

  const workTypes = [
    "Sorting unique donated items from contractors, companies, and individuals",
    "Floor staging and restocking shelves",
    "Maintaining a clean floor inventory",
    "Providing outstanding customer service",
    "Warehouse Aid for our eCommerce department",
  ];

  const schedule = [
    "Available Shifts: Tuesday - Saturday 10:00 a.m. – 2:00 p.m. and 2:00 p.m. – 5:00 p.m.",
    "We currently have limited slots to five volunteers per shift.",
    "You are also welcome to volunteer for a full day.",
  ];

  return (
    <>
      <Helmet>
        <title>
          ReStores Volunteer Opportunities - Habitat for Humanity Buffalo
        </title>
        <meta
          name="description"
          content="Volunteer at Habitat Buffalo's ReStores. Help with sorting, staging, customer service, and more to support our mission."
        />
      </Helmet>
      <Container>
        <Title>ReStores Volunteer Opportunities</Title>
        {dummyImage && (
          <Image src={dummyImage} alt="ReStores Volunteer Opportunities" />
        )}

        <Section>
          <Subtitle>Details</Subtitle>
          <p>{details}</p>
        </Section>

        <Section>
          <Subtitle>Requirements</Subtitle>
          <ul>
            {requirements.map((req, index) => (
              <li key={index}>{req}</li>
            ))}
          </ul>
        </Section>

        <Section>
          <Subtitle>Types of Work</Subtitle>
          <ul>
            {workTypes.map((workType, index) => (
              <li key={index}>{workType}</li>
            ))}
          </ul>
        </Section>

        <Section>
          <Subtitle>Schedule</Subtitle>
          <ul>
            {schedule.map((shift, index) => (
              <li key={index}>{shift}</li>
            ))}
          </ul>
        </Section>

        <ButtonContainer>
          <Button
            href="https://habitatbflo.my.site.com/volunteer/s/sign-up?jId=a0T2J00000lj1JCUAY"
            target="_blank"
            rel="noopener noreferrer"
          >
            Volunteer at the Buffalo ReStore - 1675 South Park Ave, Buffalo, NY
            14220
          </Button>
          <Button
            href="https://habitatbflo.my.site.com/volunteer/s/sign-up?jId=a0T2J00000lj1IxUAI"
            target="_blank"
            rel="noopener noreferrer"
          >
            Volunteer at the Tonawanda ReStore - 1030 Niagara Fls Blvd,
            Tonawanda, NY 14150
          </Button>
        </ButtonContainer>
      </Container>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 20px;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 20px;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const Subtitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`;

const Button = styled.a`
  background-color: #f36f25;
  color: white;
  padding: 15px;
  text-align: center;
  text-decoration: none;
  border-radius: 5px;
  font-size: 16px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e05c1b;
  }
`;

export default ReStores;
